import { z } from 'zod';
export function caseUnsensitiveEnum(enumValues) {
    return z.preprocess((val) => {
        if (typeof val === 'string') {
            return val.toUpperCase();
        }
        return val;
    }, z.enum(enumValues));
}
